import { gql } from 'urql';

export const FetchEmploymentTypes = gql`
  query EmploymentTypes {
    employmentTypes {
      id
      name
    }
  }
`;

export default FetchEmploymentTypes;
